const theme = {
  colors: {
    base: "#16233e",
    secondary: "#50e3c2",
    tertiary: "#f3f3f3",
    highlight: "#5b8bf7",
    blue: "#254ea4",
    grey: "#edf3f2",
    greyMedium: "#E4EAEB",
    greyDark: "#cddfdb",
    black: "#02003c"
  },
  sizes: {
    maxWidth: "864px", // 1200 original
    maxWidthCentered: "650px"
  },
  responsive: {
    small: "35em",
    medium: "50em",
    large: "1200px"
  }
};

export default theme;



// WEBPACK FOOTER //
// ./src/styles/theme.js